import React from 'react'
import styled from 'styled-components'
import { device } from '../../../../../config/theme/breakpoints'
import { ExclamationCircle } from '@styled-icons/heroicons-outline'

const ContainerAlert = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid #fea5003b;
  display: flex;
  flex-direction: column;

  @media ${device.mobileL}{
    flex-direction: row;
  }
`
const ContainerIcon = styled.div`
  background: #fea5003b;
  border-radius: 20px 20px 0 0;
  width: 100%;
  padding: 20px;
  display: flex;
  jutify-content: center;
  align-items: flex-start;

  > svg{
    max-width: 40px;
    color: ${p => p.theme.palette.primary.main};
  }

  @media ${device.mobileL}{
    max-width: 8%;
    border-radius: 18px 0 0 18px;
  }
`

const ContainerText = styled.div`
  padding: 10px 15px;
  background: #fea5003b;
  border-radius: 0 20px 20px 0;
  width: 100%;

  > h3{
    color: ${p => p.theme.palette.text.primary};
    text-align: center;

    @media ${device.mobileL}{
      text-align: left;
    }
  }

  > p{
    font-weight: 100;
    font-size: 12px;
  }
`

const AlertInfo: React.FunctionComponent = () => {
  return (
    <ContainerAlert>
      <ContainerIcon>
        <ExclamationCircle />
      </ContainerIcon>
      <ContainerText>
        <h3>Si vas a pagar con tu tarjeta de crédito, recuerda:</h3>
        <p>
            - Pedir autorización en tu banco para realizar compras por internet con este medio de pago. <br/>
            - Tu banco puede cobrarte comisiones y/o importes adicionales por el uso de la tarjeta. <br/>
            - Si quieres pagar con Visa, la tarjeta debe ser emitida por una entidad bancaria y estar registrada en el servicio Verified by Visa. <br/>
            - Según la tarifa y la anticipación con la que compres tu pasaje, algunos medios de pago podrían no estar disponibles. <br/>
        </p>
      </ContainerText>
    </ContainerAlert>
  )
}

export default AlertInfo